var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraColored = function SvgCameraColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#camera-colored_svg__a)",
    fillRule: "evenodd",
    d: "M8.293 3.293A1 1 0 0 1 9 3h6a1 1 0 0 1 .707.293L17.414 5H21a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V4h2v1h.586zM9.414 5 7.707 6.707A1 1 0 0 1 7 7H4v11h16V7h-3a1 1 0 0 1-.707-.293L14.586 5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#camera-colored_svg__b)",
    fillRule: "evenodd",
    d: "M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-colored_svg__a",
    x1: 2,
    x2: 22,
    y1: 20,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F9B233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A09A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera-colored_svg__b",
    x1: 2,
    x2: 22,
    y1: 20,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F9B233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A09A"
  })))));
};
export default SvgCameraColored;